import React from "react";
import NumberFormat from "react-number-format";

interface PercentNumberFormatProps {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  suffix: string;
  [key: string]: any;
}

const PercentNumberFormat = ({
  inputRef,
  onChange,
  name,
  suffix,
  ...rest
}: PercentNumberFormatProps) => (
  <NumberFormat
    {...rest}
    getInputRef={inputRef}
    onValueChange={(values: any) => {
      onChange({ target: { name, value: values.value } });
    }}
    thousandSeparator=","
    decimalSeparator="."
    decimalScale={2}
    fixedDecimalScale
    isNumericString
    suffix={suffix}
    name={name}
    // Split % is bounded 0-100: block the minus sign and reject any keystroke
    // that would push the value past 100.
    allowNegative={false}
    isAllowed={({ floatValue }: any) =>
      floatValue === undefined || (floatValue >= 0 && floatValue <= 100)
    }
  />
);

export default PercentNumberFormat;
